/*
 * ==============================================================================
 *
 * Copyright (c) 2023. Koninklijke Philips Electronics N.V.
 *
 * All rights are reserved. Reproduction in whole or in part is prohibited without the prior written consent of the copyright holder.
 *
 * ==============================================================================
 */

import React from "react";
import LeadDetailsGraph from "./LeadDetailsGraph";
import { useState } from "react";
import { useParams } from "react-router-dom";
import { useContext } from "react";
import { Dashboard2Context } from "./dashboard2";

const data = [
  {
    id: 4,
    month: "2020-MAY",
    unique: "1",
    view: "1",
  },
  {
    id: 1,
    month: "2016-JAN",
    unique: "1",
    view: "2",
  },
  {
    id: 2,
    month: "2020-MAR",
    unique: "1",
    view: "5",
  },
  {
    id: 3,
    month: "2020-APR",
    unique: "1",
    view: "5",
  },
  {
    id: 5,
    month: "2020-JUN",
    unique: "1",
    view: "7",
  },
  {
    id: 6,
    month: "2020-JUL",
    unique: "1",
    view: "9",
  },
];

const LeadDetails = ({ userInfo, onClickHide, visible, renderHideButton, ...props }) => {
  const { updateUserInfo } = useContext(Dashboard2Context);
  const [u, setU] = useState(userInfo);
  const { i } = useParams();

  const onChange = ({ key, value, dataKey }) => {
    updateUserInfo({ ...userInfo, [dataKey]: value });
    const trend = JSON.parse(u.patient.trend || "[]");
    const date = new Date(userInfo.interrogationDate).toLocaleDateString().split("/");
    const dateKey = [date[2], parseInt(date[0]).pad(2), parseInt(date[1]).pad(2)].join("-");
    let index = -1;
    trend.forEach((item, _index) => {
      if (item.id === parseInt(i) && item.irDate === dateKey) {
        index = _index;
      }
    });
    data[key] = value;
    if (index >= 0) {
      trend[index] = {
        ...trend[index],
        [key]: value,
      };
    } else {
      trend.push({
        irDate: dateKey,
        ra: "0",
        rv: "0",
        lv: "0",
        [key]: value,
      });
    }
    setU({ ...u, patient: { ...u.patient, trend: JSON.stringify(trend) } });
  };
  return (
    <div {...props}>
      <div className="grp-hdr">
        <button className="btn btn-sm btn-hide-section" onClick={onClickHide}>
          {renderHideButton}
        </button>
        <h3>Lead Details</h3>
      </div>
      {visible ? (
        <div style={{ display: "flex", flex: 1 }}>
          <div style={{ display: "flex", flex: 1 }}>
            <LeadDetailsGraph
              data={data}
              color="rgba(87, 205, 148, .5)"
              dataKey="raImpedance"
              userInfo={u}
              trendKey="ra"
              onChange={onChange}
            />
            <LeadDetailsGraph
              data={data}
              color="rgba(226, 189, 56, .5)"
              dataKey="rvImpedance"
              userInfo={u}
              trendKey="rv"
              onChange={onChange}
            />
            <LeadDetailsGraph
              data={data}
              color="rgba(231, 110, 161, .5)"
              dataKey="lvImpedance"
              userInfo={u}
              trendKey="lv"
              onChange={onChange}
            />
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default LeadDetails;
